import React from 'react';
import { Shield, Users, Award } from 'lucide-react';
import { aboutContent } from '../data/mock';

const About = () => {
  const values = [
    {
      icon: <Shield className="w-6 h-6" />,
      title: "Transparent",
      description: "Clear communication at every step"
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: "Client-Focused",
      description: "Your goals drive our approach"
    },
    {
      icon: <Award className="w-6 h-6" />,
      title: "Professional",
      description: "Licensed and insured partners"
    }
  ];

  return (
    <section
      id="about"
      className="section-padding relative grid-pattern"
      style={{ backgroundColor: '#1F3B60' }}
    >
      {/* Background accent */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full blur-3xl"
        style={{ background: 'rgba(214, 169, 79, 0.05)' }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <span className="inline-block font-semibold text-xs tracking-[0.2em] uppercase mb-4 px-4 py-1.5 rounded-full" style={{ color: '#D6A94F', backgroundColor: 'rgba(214, 169, 79, 0.1)', border: '1px solid rgba(214, 169, 79, 0.2)' }}>
              About Pacific Crest
            </span>
            <h2 className="font-display font-bold text-4xl sm:text-5xl text-white mb-6">
              {aboutContent.title.replace('About ', '')}
            </h2>
            <div className="divider-gold mb-8" />

            <div className="space-y-6">
              {aboutContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-lg text-white/70 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          {/* Values cards */}
          <div className="space-y-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="card-navy p-6 flex items-start space-x-5 group hover:border-white/20 transition-all duration-300 hover:-translate-x-2"
              >
                <div className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300" style={{ background: 'linear-gradient(135deg, #D6A94F, #E4C078)', color: '#1F3B60' }}>
                  {value.icon}
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-white mb-1">
                    {value.title}
                  </h3>
                  <p className="text-white/60">
                    {value.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
